<script setup lang="ts">
withDefaults(
  defineProps<{
    loadingTemplate?: number;
  }>(),
  {
    loadingTemplate: 5,
  }
);
</script>

<template>
  <div class="flex flex-col gap-4">
    <div
      v-for="x in loadingTemplate"
      class="grid grid-cols-[125px_1fr] items-center"
      :key="x"
    >
      <Skeleton
        class="rounded-3"
        height="20px"
        width="100px"
      />

      <Skeleton
        class="rounded-3"
        height="20px"
        width="100%"
      />
    </div>
  </div>
</template>
